// extracted by mini-css-extract-plugin
export default {"cls1":"zLTzB6KFJ2iGmE7vvtCO","cls2":"JSYDEb5nm3EJnnS8Oqfr zLTzB6KFJ2iGmE7vvtCO","isTabletUp":"kJzuTM6oSEn5v_u5XjDN"};